/**
 * Insurance Companies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageFinancialRequestsComponent,
  AsyncSimpleFinancialRequestsComponent,
  AsyncExportedFinancialRequestsComponent,
  AsyncCreditCardReportComponent,
  AsyncAgencyDiscountedPricesComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageFinancialRequestsComponent}
      />
      <Route
        path={`${match.url}/view-simple`}
        component={AsyncSimpleFinancialRequestsComponent}
      />
      <Route
        path={`${match.url}/view-exported`}
        component={AsyncExportedFinancialRequestsComponent}
      />
      <Route
        path={`${match.url}/credit-card`}
        component={AsyncCreditCardReportComponent}
      />
      <Route
        path={`${match.url}/agency-discounted-prices`}
        component={AsyncAgencyDiscountedPricesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
